
export default function mapit() {
  'use strict';

  const HOVER_DELAY   = 150;
  const CLOSE_DELAY   = 300;
  const VISIBLE_CLASS = 'is-visible';
  const ACTIVE_CLASS  = 'is-active';

  const container = document.getElementById('mapInteractive');
  if (!container) return;

  const pins     = container.querySelectorAll('.map-interactive__pin--primary');
  const tooltips = container.querySelectorAll('.map-interactive__tooltip');

  let activeCity   = null;
  let hoverTimeout = null;
  let closeTimeout = null;
  let isClickMode  = false;

  function getTooltip(city) {
    return container.querySelector(`.map-interactive__tooltip[data-tt="${city}"]`);
  }

  function showTooltip(city) {
    hideAll();
    const tooltip = getTooltip(city);
    const pin = container.querySelector(`.map-interactive__pin[data-city="${city}"]`);
    if (!tooltip) return;
    tooltip.classList.add(VISIBLE_CLASS);
    if (pin) pin.classList.add(ACTIVE_CLASS);
    activeCity = city;
  }

  function hideAll() {
    tooltips.forEach(t => t.classList.remove(VISIBLE_CLASS));
    pins.forEach(p => p.classList.remove(ACTIVE_CLASS));
    activeCity = null;
    isClickMode = false;
  }

  function clearTimers() {
    clearTimeout(hoverTimeout);
    clearTimeout(closeTimeout);
  }

  // CLICK
  pins.forEach(pin => {
    pin.addEventListener('click', function (e) {
      e.stopPropagation();
      const city = this.dataset.city;
      clearTimers();
      if (activeCity === city && isClickMode) { hideAll(); }
      else { showTooltip(city); isClickMode = true; }
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.map-interactive__tooltip') &&
        !e.target.closest('.map-interactive__pin--primary')) {
      clearTimers(); hideAll();
    }
  });

  // HOVER
  pins.forEach(pin => {
    pin.addEventListener('mouseenter', function () {
      if (isClickMode) return;
      clearTimers();
      hoverTimeout = setTimeout(() => showTooltip(this.dataset.city), HOVER_DELAY);
    });
    pin.addEventListener('mouseleave', function () {
      if (isClickMode) return;
      clearTimers();
      closeTimeout = setTimeout(() => {
        const tooltip = getTooltip(activeCity);
        if (tooltip && tooltip.matches(':hover')) return;
        hideAll();
      }, CLOSE_DELAY);
    });
  });

  tooltips.forEach(tooltip => {
    tooltip.addEventListener('mouseenter', () => { if (!isClickMode) clearTimers(); });
    tooltip.addEventListener('mouseleave', () => {
      if (!isClickMode) { clearTimers(); closeTimeout = setTimeout(hideAll, CLOSE_DELAY); }
    });
  });

  // ESCAPE
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { clearTimers(); hideAll(); } });
}
